// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.colorPickerContainer_a7EiB {
  width: 80%;
  max-width: 500px;

  margin: 10px auto;
  border-radius: 8px;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  -ms-border-radius: 8px;
  -o-border-radius: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/ColorPicker/ColorPicker.module.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,gBAAgB;;EAEhB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;AACvB","sourcesContent":[".colorPickerContainer {\n  width: 80%;\n  max-width: 500px;\n\n  margin: 10px auto;\n  border-radius: 8px;\n  padding: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  -ms-border-radius: 8px;\n  -o-border-radius: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colorPickerContainer": `colorPickerContainer_a7EiB`
};
export default ___CSS_LOADER_EXPORT___;
